/** misc: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "bootTitle": "Displaro couldn't open",
  "bootBody": "The page didn't load, often because the server or network was waking up. Try again; if it keeps happening, the details below help us find out why.",
  "bootRetry": "Try again",
  "nPlayersHere": "{n} players here",
  "andNMore": "and {n} more",
  "takeShots": "{on} of {total} player take screenshots | {on} of {total} players take screenshots",
  "screenOf": "{name} screen",
  "everyMin": "· every {n} min",
  "everyH": "· every {n} h",
  "lastSeen": "Offline · last seen {ago}",
  "screenAt": "Screen at {when}",
  "shotAt": "Screenshot at {when}",
  "signedOutN": "Signed out {n} other session | Signed out {n} other sessions",
  "browser": "Browser",
  "browserOn": "{browser} on {os}",
  "sessionLine": "{ip} · active {active} · signed in {signed}",
  "chooseFeedFor": "Choose a data feed for “{name}”",
  "customAppV": "Custom app · version {v}",
  "newX": "New {name}",
  "app": "app",
  "manageX": "Manage “{name}”",
  "feedRows": "{name} ({n} rows)",
  "monTitle": "Monitoring",
  "monIntro": "What each player is showing, from the screenshots it takes on its schedule. Kept 7 days.",
  "shotSchedule": "Screenshot schedule",
  "searchPlayers": "Search players",
  "playerGroup": "Player group",
  "allGroups": "All groups",
  "retry": "Retry",
  "shotsOffAll": "Screenshots are off for every player. Turn them on in Player Settings → Monitoring, for the whole organization or for single players.",
  "shotFromGroup": "From group “{name}”",
  "shotFromOrg": "Organization default",
  "shotFromPlayer": "Set for this player",
  "shotInherit": "Inherit ({what})",
  "shotSaved": "Screenshot schedule saved · applies at the player's next sync",
  "shotsOff": "Screenshots off",
  "shotsOffAllShort": "Screenshots are off for every player.",
  "shotsTurnOnAll": "Turn on for all players",
  "shotsAllOnQ": "Every player will take a screenshot every 15 minutes and upload it (kept 7 days). Screenshots show what's on screen, and use some data. Change how often, or Wi-Fi only, in Player Settings → Monitoring.",
  "shotsOnAllDone": "Screenshots on for all players, every 15 minutes",
  "shotsTurnOn": "Turn on",
  "shotsTurnOff": "Turn off",
  "shotsOnOne": "Screenshots on for “{name}”",
  "shotsOffOne": "Screenshots off for “{name}”",
  "shotsWaiting": "Screenshots on · waiting for the player",
  "noShotYet": "No screenshot yet",
  "stale": "Stale",
  "online": "Online",
  "offline": "Offline",
  "loading": "Loading…",
  "noMatch": "No players match.",
  "noPlayers": "No players yet",
  "pairFirst": "Pair a player, then turn on screenshots in Player Settings.",
  "neverConnected": "Never connected",
  "openPlayer": "Open player",
  "close": "Close",
  "noShots7": "No screenshots from this player in the last 7 days.",
  "older": "← Older",
  "newer": "Newer →",
  "shotsList": "Screenshots, newest first",
  "olderMore": "Older…",
  "dragCentre": "Drag to move the centre",
  "dragRadius": "Drag to make the circle bigger or smaller",
  "dragCorner": "Drag to move this corner · double-click to remove it",
  "dragToAddCorner": "Drag to add a corner here",
  "checkForm": "Check the form",
  "noMatchPw": "The new passwords don’t match",
  "repeatPw": "Repeat the new password",
  "pwChanged": "Password changed · other browsers were signed out",
  "signedOutThat": "Signed out that browser",
  "signOutAllQ": "Sign out every other browser and device?",
  "unknownBrowser": "Unknown browser",
  "changePw": "Change password",
  "currentPw": "Current password",
  "newPw": "New password",
  "pwRule": "At least 12 characters.",
  "repeatNewPw": "Repeat new password",
  "changing": "Changing…",
  "pwHint": "Changing it signs out every other browser and device.",
  "whereSignedIn": "Where you’re signed in",
  "signOutElse": "Sign out everywhere else",
  "thisBrowser": "This browser",
  "unknownAddr": "Unknown address",
  "signOut": "Sign out",
  "name": "Name",
  "currentVersion": "Plays the app’s current version.",
  "cancel": "Cancel",
  "create": "Create",
  "save": "Save",
  "saving": "Saving…",
  "noSettings": "This app has no settings.",
  "dataFeedTag": "(data feed)",
  "chooseFeed": "Choose a data feed",
  "none": "None",
  "noFeeds": "No data feeds yet.",
  "createOne": "Create one",
  "orientation": "Orientation",
  "restart": "Restart",
  "appPreview": "App preview",
  "previewNote": "Preview in the browser. Players run the same files offline in a sandboxed web view.",
  "emptyPlaylist": "Empty playlist",
  "moreItems": "{n} more items",
  "ciVideos": "Too many videos",
  "ciCoords": "Missing coordinates",
  "ciCanvas": "Canvas size mismatch",
  "ciEmpty": "Empty zone",
  "ciDuration": "Missing duration",
  "ciNothing": "Nothing was published",
  "noOrg": "You don't belong to any organization yet. Ask an admin for an invitation."
};
const ar: typeof en = {
  "bootTitle": "تعذّر فتح Displaro",
  "bootBody": "لم تُحمَّل الصفحة، وغالبًا لأن الخادم أو الشبكة كانا يستيقظان. حاول مرة أخرى؛ وإن تكرر ذلك فالتفاصيل أدناه تساعدنا على معرفة السبب.",
  "bootRetry": "حاول مرة أخرى",
  "nPlayersHere": "{n} مشغلات هنا",
  "andNMore": "و{n} أخرى",
  "takeShots": "{on} من {total} مشغل تلتقط لقطات | {on} من مشغل واحد يلتقط لقطات | {on} من مشغلين تلتقط لقطات | {on} من {total} مشغلات تلتقط لقطات | {on} من {total} مشغلًا تلتقط لقطات | {on} من {total} مشغل تلتقط لقطات",
  "screenOf": "شاشة {name}",
  "everyMin": "· كل {n} دقيقة",
  "everyH": "· كل {n} ساعة",
  "lastSeen": "غير متصل · آخر ظهور {ago}",
  "screenAt": "الشاشة في {when}",
  "shotAt": "لقطة في {when}",
  "signedOutN": "لم تُغلق أي جلسة | تم تسجيل الخروج من جلسة أخرى واحدة | تم تسجيل الخروج من جلستين أخريين | تم تسجيل الخروج من {n} جلسات أخرى | تم تسجيل الخروج من {n} جلسة أخرى | تم تسجيل الخروج من {n} جلسة أخرى",
  "browser": "متصفح",
  "browserOn": "{browser} على {os}",
  "sessionLine": "{ip} · نشط {active} · سجّل الدخول {signed}",
  "chooseFeedFor": "اختر مصدر بيانات لـ «{name}»",
  "customAppV": "تطبيق مخصص · الإصدار {v}",
  "newX": "{name} جديد",
  "app": "تطبيق",
  "manageX": "إدارة «{name}»",
  "feedRows": "{name} ({n} صف)",
  "monTitle": "المراقبة",
  "monIntro": "ما يعرضه كل مشغل، من لقطات الشاشة التي يلتقطها وفق جدوله. تُحفظ ٧ أيام.",
  "shotSchedule": "جدول لقطات الشاشة",
  "searchPlayers": "البحث في المشغلات",
  "playerGroup": "مجموعة المشغلات",
  "allGroups": "كل المجموعات",
  "retry": "إعادة المحاولة",
  "shotsOffAll": "لقطات الشاشة متوقفة لكل المشغلات. فعّلها في إعدادات المشغل ← المراقبة، للمؤسسة كلها أو لمشغلات منفردة.",
  "shotsOff": "لقطات الشاشة متوقفة",
  "shotFromGroup": "من المجموعة «{name}»",
  "shotFromOrg": "الإعداد الافتراضي للمؤسسة",
  "shotFromPlayer": "مُعيَّن لهذا المشغل",
  "shotInherit": "وراثة ({what})",
  "shotSaved": "تم حفظ جدول لقطات الشاشة · يُطبَّق عند المزامنة التالية للمشغل",
  "shotsOffAllShort": "لقطات الشاشة متوقفة لجميع المشغلات.",
  "shotsTurnOnAll": "تشغيلها لجميع المشغلات",
  "shotsAllOnQ": "سيلتقط كل مشغل لقطة شاشة كل 15 دقيقة ويرفعها (تُحفظ 7 أيام). تُظهر اللقطات ما على الشاشة وتستهلك بعض البيانات. غيّر التكرار أو اختر Wi-Fi فقط من إعدادات المشغل ← المراقبة.",
  "shotsOnAllDone": "تم تشغيل لقطات الشاشة لجميع المشغلات كل 15 دقيقة",
  "shotsTurnOn": "تشغيل",
  "shotsTurnOff": "إيقاف",
  "shotsOnOne": "تم تشغيل لقطات الشاشة لـ «{name}»",
  "shotsOffOne": "تم إيقاف لقطات الشاشة لـ «{name}»",
  "shotsWaiting": "اللقطات مفعّلة · بانتظار المشغل",
  "noShotYet": "لا توجد لقطة بعد",
  "stale": "قديمة",
  "online": "متصل",
  "offline": "غير متصل",
  "loading": "جارٍ التحميل…",
  "noMatch": "لا توجد مشغلات مطابقة.",
  "noPlayers": "لا توجد مشغلات بعد",
  "pairFirst": "أقرن مشغلًا، ثم فعّل لقطات الشاشة في إعدادات المشغل.",
  "neverConnected": "لم يتصل قط",
  "openPlayer": "فتح المشغل",
  "close": "إغلاق",
  "noShots7": "لا توجد لقطات من هذا المشغل في آخر ٧ أيام.",
  "older": "← الأقدم",
  "newer": "الأحدث →",
  "shotsList": "لقطات الشاشة، الأحدث أولًا",
  "olderMore": "الأقدم…",
  "dragCentre": "اسحب لتحريك المركز",
  "dragRadius": "اسحب لتكبير الدائرة أو تصغيرها",
  "dragCorner": "اسحب لتحريك هذه الزاوية · انقر مرتين لحذفها",
  "dragToAddCorner": "اسحب لإضافة زاوية هنا",
  "checkForm": "تحقق من النموذج",
  "noMatchPw": "كلمتا المرور الجديدتان غير متطابقتين",
  "repeatPw": "أعد كتابة كلمة المرور الجديدة",
  "pwChanged": "تم تغيير كلمة المرور · تم تسجيل الخروج من المتصفحات الأخرى",
  "signedOutThat": "تم تسجيل الخروج من ذلك المتصفح",
  "signOutAllQ": "تسجيل الخروج من كل المتصفحات والأجهزة الأخرى؟",
  "unknownBrowser": "متصفح غير معروف",
  "changePw": "تغيير كلمة المرور",
  "currentPw": "كلمة المرور الحالية",
  "newPw": "كلمة المرور الجديدة",
  "pwRule": "١٢ حرفًا على الأقل.",
  "repeatNewPw": "أعد كتابة كلمة المرور الجديدة",
  "changing": "جارٍ التغيير…",
  "pwHint": "تغييرها يسجّل الخروج من كل المتصفحات والأجهزة الأخرى.",
  "whereSignedIn": "حيث سجّلت الدخول",
  "signOutElse": "تسجيل الخروج من كل مكان آخر",
  "thisBrowser": "هذا المتصفح",
  "unknownAddr": "عنوان غير معروف",
  "signOut": "تسجيل الخروج",
  "name": "الاسم",
  "currentVersion": "يعرض الإصدار الحالي من التطبيق.",
  "cancel": "إلغاء",
  "create": "إنشاء",
  "save": "حفظ",
  "saving": "جارٍ الحفظ…",
  "noSettings": "لا توجد إعدادات لهذا التطبيق.",
  "dataFeedTag": "(مصدر بيانات)",
  "chooseFeed": "اختر مصدر بيانات",
  "none": "بلا",
  "noFeeds": "لا توجد مصادر بيانات بعد.",
  "createOne": "أنشئ واحدًا",
  "orientation": "الاتجاه",
  "restart": "إعادة التشغيل",
  "appPreview": "معاينة التطبيق",
  "previewNote": "معاينة في المتصفح. تشغّل المشغلات الملفات نفسها دون اتصال في عارض ويب معزول.",
  "emptyPlaylist": "قائمة تشغيل فارغة",
  "moreItems": "{n} عناصر أخرى",
  "ciVideos": "فيديوهات كثيرة جدًا",
  "ciCoords": "الإحداثيات مفقودة",
  "ciCanvas": "عدم تطابق حجم اللوحة",
  "ciEmpty": "قسم فارغ",
  "ciDuration": "المدة مفقودة",
  "ciNothing": "لم يُنشر شيء",
  "noOrg": "لا تنتمي إلى أي مؤسسة بعد. اطلب دعوة من أحد المسؤولين."
};
export default { en, ar };
